import type {
  SocialExtractionResponse,
  SocialProfileResponse,
} from "contracts/api/social/admin";
import { SOCIAL_EXTRACTION_STATUS } from "contracts/enums/social";
import { SOCIAL_PLATFORM_LABELS } from "contracts/enums/social-labels";
import { Show } from "solid-js";
import { SOCIAL_EXTRACTION_STATUS_LABELS } from "../../enums/admin-social";

export function SocialProfileCard(props: {
  profile: SocialProfileResponse;
  extraction: SocialExtractionResponse | undefined;
  busy: boolean;
  onStart: () => void;
  onStop: (runId: string) => void;
  onResume: (runId: string) => void;
}) {
  const active = () => props.extraction && isActive(props.extraction.status);
  const resumable = () =>
    props.extraction &&
    (props.extraction.status === SOCIAL_EXTRACTION_STATUS.STOPPED ||
      props.extraction.status === SOCIAL_EXTRACTION_STATUS.FAILED);
  return (
    <article class="social-profile-card">
      <div class="social-card-head">
        <div>
          <strong>{SOCIAL_PLATFORM_LABELS[props.profile.platform]}</strong>
          <a href={props.profile.profileUrl} target="_blank" rel="noreferrer">
            @{props.profile.handle}
          </a>
        </div>
        <span class="social-state">
          {props.extraction
            ? SOCIAL_EXTRACTION_STATUS_LABELS[props.extraction.status]
            : "Not extracted"}
        </span>
      </div>
      <Show when={props.extraction}>
        {(extraction) => (
          <div class="social-run-facts mono">
            <span>{extraction().acceptedPosts} accepted</span>
            <span>{extraction().rejectedItems} rejected</span>
            <span>offset {extraction().datasetOffset}</span>
            <Show when={extraction().providerRunId}>
              {(runId) => <span>Actor {runId()}</span>}
            </Show>
          </div>
        )}
      </Show>
      <Show when={props.extraction?.error}>
        {(error) => <div class="gate-error">{error()}</div>}
      </Show>
      <div class="social-actions">
        <Show when={!active() && !resumable()}>
          <button
            class="btn"
            type="button"
            disabled={props.busy}
            onClick={props.onStart}
          >
            {props.extraction ? "Extract again" : "Start extraction"}
          </button>
        </Show>
        <Show when={active() && props.extraction}>
          {(extraction) => (
            <button
              class="btn"
              type="button"
              disabled={
                props.busy ||
                extraction().status === SOCIAL_EXTRACTION_STATUS.STOPPING
              }
              onClick={() => props.onStop(extraction().id)}
            >
              Stop
            </button>
          )}
        </Show>
        <Show when={resumable() && props.extraction}>
          {(extraction) => (
            <button
              class="btn"
              type="button"
              disabled={props.busy}
              onClick={() => props.onResume(extraction().id)}
            >
              Resume
            </button>
          )}
        </Show>
      </div>
    </article>
  );
}

function isActive(status: SocialExtractionResponse["status"]): boolean {
  return (
    status === SOCIAL_EXTRACTION_STATUS.QUEUED ||
    status === SOCIAL_EXTRACTION_STATUS.STARTING ||
    status === SOCIAL_EXTRACTION_STATUS.RUNNING ||
    status === SOCIAL_EXTRACTION_STATUS.IMPORTING ||
    status === SOCIAL_EXTRACTION_STATUS.STOPPING
  );
}
